var render = function render(){
  var _vm$filteredFleets;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "visible": _vm.isOpen,
      "id": "add-init",
      "size": "xl",
      "title": _vm.title,
      "header-bg-variant": "light",
      "header-text-variant": "dark",
      "footer-bg-variant": "light",
      "footer-text-variant": "dark",
      "hide-footer": _vm.isPreview,
      "ok-title": "Next",
      "ok-disabled": !_vm.fleets.checkeds.length
    },
    on: {
      "hide": function hide($event) {
        return _vm.$emit('close');
      },
      "ok": _vm.handleOkClick
    }
  }, [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Search fleets..."
    },
    model: {
      value: _vm.fleets.params.search,
      callback: function callback($$v) {
        _vm.$set(_vm.fleets.params, "search", $$v);
      },
      expression: "fleets.params.search"
    }
  })], 1)], 1), _vm.fleets.loading ? _c('div', {
    staticClass: "text-center my-5"
  }, [_c('b-spinner', {
    attrs: {
      "type": "grow",
      "label": "Spinning"
    }
  })], 1) : [((_vm$filteredFleets = _vm.filteredFleets) === null || _vm$filteredFleets === void 0 ? void 0 : _vm$filteredFleets.length) > 0 ? _c('div', {
    staticStyle: {
      "max-height": "68vh",
      "overflow": "auto"
    }
  }, [_c('b-row', {
    staticClass: "w-100"
  }, _vm._l(_vm.filteredFleets, function (fleet, i) {
    var _fleet$vehicle_img$ur, _fleet$vehicle_img, _fleet$vehicle_type_i, _fleet$vehicle;
    return _c('b-col', {
      key: "fleet-".concat(i),
      staticClass: "text-center pb-5",
      attrs: {
        "md": "3"
      }
    }, [_c('div', {
      staticStyle: {
        "min-height": "100px"
      }
    }, [_c('label', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "for": "ck-fl-".concat(i)
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "120px",
        "min-height": "120px",
        "object-fit": "cover"
      },
      attrs: {
        "src": (_fleet$vehicle_img$ur = fleet === null || fleet === void 0 ? void 0 : (_fleet$vehicle_img = fleet.vehicle_img) === null || _fleet$vehicle_img === void 0 ? void 0 : _fleet$vehicle_img.url) !== null && _fleet$vehicle_img$ur !== void 0 ? _fleet$vehicle_img$ur : fleet === null || fleet === void 0 ? void 0 : (_fleet$vehicle_type_i = fleet.vehicle_type_icon) === null || _fleet$vehicle_type_i === void 0 ? void 0 : _fleet$vehicle_type_i.url,
        "alt": "#"
      }
    }), _c('div', {
      staticClass: "d-flex justify-content-center align-items-center mt-2"
    }, [!_vm.isPreview ? _c('b-form-checkbox', {
      attrs: {
        "id": "ck-fl-".concat(i),
        "value": fleet.vehicle_id
      },
      model: {
        value: _vm.fleets.checkeds,
        callback: function callback($$v) {
          _vm.$set(_vm.fleets, "checkeds", $$v);
        },
        expression: "fleets.checkeds"
      }
    }) : _vm._e(), _c('strong', [_vm._v(" " + _vm._s((fleet === null || fleet === void 0 ? void 0 : fleet.vehicle_name) || (fleet === null || fleet === void 0 ? void 0 : (_fleet$vehicle = fleet.vehicle) === null || _fleet$vehicle === void 0 ? void 0 : _fleet$vehicle.name)) + " ")])], 1)])])]);
  }), 1)], 1) : _c('div', {
    staticClass: "text-center my-5"
  }, [_c('p', {
    staticClass: "mb-0 text-muted"
  }, [_vm._v("No fleets data found.")])])]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }